export default function (cfpLoadingBarProvider) {
  cfpLoadingBarProvider.includeSpinner = false;
  cfpLoadingBarProvider.parentSelector = ".loading-bar-container";
}



// WEBPACK FOOTER //
// ./src/core/configs.js